// @flow
import React from 'react'
import './styles.scss'
import { Spring, config } from 'react-spring/renderprops.cjs'
import { Waypoint } from 'react-waypoint'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

const isMobile = window.innerWidth < 600
const countDuration = 1500

export class CareerStats extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isInView: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className='career-stats'>
        <div className='ui equal width center aligned padded grid'>
          <img src={require('./rackets.svg')} />
          <h5>Karrierestatistik</h5>
          <div className='row'>
            <div className='left column'>
              <div className='column-header'>Einzel</div>
              <table className='ui very basic small unstackable celled table'>
                <tbody>
                  <tr className='titled'>
                    <td colSpan='2'>Siegquote</td>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <div>
                        <Spring
                          from={{ number: 0 }}
                          to={{
                            number: 80.2
                          }}
                          config={{
                            duration: countDuration
                          }}
                          reset={{ number: this.state.isIn === 'init' }}
                        >
                          {props => <>{props.number.toFixed(1)}</>}
                        </Spring>
                        %{' '}
                        <span className='sid'>
                          (
                          <Spring
                            from={{ number: 0 }}
                            to={{
                              number: 548
                            }}
                            config={{
                              duration: countDuration
                            }}
                            reset={{ number: this.state.isIn === 'init' }}
                          >
                            {props => <>{parseInt(props.number)}</>}
                          </Spring>
                          /
                          <Spring
                            from={{ number: 0 }}
                            to={{
                              number: 135
                            }}
                            config={{
                              duration: countDuration
                            }}
                            reset={{ number: this.state.isIn === 'init' }}
                          >
                            {props => <>{parseInt(props.number)}</>}
                          </Spring>
                          )
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr className='titled'>
                    <td colSpan='2'>Turniersiege</td>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <Spring
                        from={{ number: 0 }}
                        to={{
                          number: 43
                        }}
                        config={{
                          duration: countDuration
                        }}
                        reset={{ number: this.state.isIn === 'init' }}
                      >
                        {props => <div>{parseInt(props.number)}</div>}
                      </Spring>
                    </td>
                  </tr>
                  <tr className='titled'>
                    <td colSpan='2'>Grand-Slam-Titel</td>
                  </tr>
                  <tr>
                    <td>
                      <div>Australian Open</div>
                    </td>
                    <td>
                      <div>
                        1997
                        <br />
                        1998
                        <br />
                        1999
                      </div>
                    </td>
                  </tr>
                  <tr className='sep'>
                    <td colSpan='2'>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>Wimbledon</div>
                    </td>
                    <td>
                      <div>1997</div>
                    </td>
                  </tr>
                  <tr className='sep'>
                    <td colSpan='2'>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>US Open</div>
                    </td>
                    <td>
                      <div>1997</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='right column'>
              <div className='column-header'>Doppel</div>
              <table className='ui very basic small unstackable celled table'>
                <tbody>
                  <tr className='titled'>
                    <td colSpan='2'>Siegquote</td>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <div>
                        <Spring
                          from={{ number: 0 }}
                          to={{
                            number: 81.7
                          }}
                          config={{
                            duration: countDuration
                          }}
                          reset={{ number: this.state.isIn === 'init' }}
                        >
                          {props => <>{props.number.toFixed(1)}</>}
                        </Spring>
                        %{' '}
                        <span className='sid'>
                          (
                          <Spring
                            from={{ number: 0 }}
                            to={{
                              number: 490
                            }}
                            config={{
                              duration: countDuration
                            }}
                            reset={{ number: this.state.isIn === 'init' }}
                          >
                            {props => <>{parseInt(props.number)}</>}
                          </Spring>
                          /
                          <Spring
                            from={{ number: 0 }}
                            to={{
                              number: 110
                            }}
                            config={{
                              duration: countDuration
                            }}
                            reset={{ number: this.state.isIn === 'init' }}
                          >
                            {props => <>{parseInt(props.number)}</>}
                          </Spring>
                          )
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr className='titled'>
                    <td colSpan='2'>Turniersiege</td>
                  </tr>
                  <tr>
                    <td colSpan='2'>
                      <Spring
                        from={{ number: 0 }}
                        to={{
                          number: 64
                        }}
                        config={{
                          duration: countDuration
                        }}
                        reset={{ number: this.state.isIn === 'init' }}
                      >
                        {props => <div>{parseInt(props.number)}</div>}
                      </Spring>
                    </td>
                  </tr>
                  <tr className='titled'>
                    <td colSpan='2'>Grand-Slam-Titel</td>
                  </tr>
                  <tr>
                    <td>
                      <div>Australian Open</div>
                    </td>
                    <td>
                      <div>
                        1997
                        <br />
                        1998
                        <br />
                        1999
                        <br />
                        2002
                        <br />
                        2016
                      </div>
                    </td>
                  </tr>
                  <tr className='sep'>
                    <td colSpan='2'>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>French Open</div>
                    </td>
                    <td>
                      <div>
                        1998
                        <br />
                        2000
                      </div>
                    </td>
                  </tr>
                  <tr className='sep'>
                    <td colSpan='2'>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>Wimbledon</div>
                    </td>
                    <td>
                      <div>
                        1996
                        <br />
                        1998
                        <br />
                        2015
                      </div>
                    </td>
                  </tr>
                  <tr className='sep'>
                    <td colSpan='2'>
                      <hr />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>US Open</div>
                    </td>
                    <td>
                      <div>
                        1998
                        <br />
                        2015
                        <br />
                        2017
                      </div>
                    </td>
                  </tr>
                  <tr className='titled'>
                    <td colSpan='2'>Olympische Spiele</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <div>Rio 2016</div>
                    </td>
                    <td>
                      <div>Silber</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <figcaption>
            Quelle:{' '}
            <a href='https://www.wtatennis.com/players/80301/martina-hingis'>
              WTA
            </a>
          </figcaption>
        </div>
        <Waypoint
          bottomOffset='-50%'
          onEnter={event => {
            // console.log('isInView')
            this.setState({ isInView: true })
          }}
          onLeave={event => {
            // console.log('NOT isInView')
            this.setState({ isInView: false })
          }}
        />
      </div>
    )
  }
}
